import { Button, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import {
    TbDownload,
    TbLayoutSidebarLeftExpand,
    TbLayoutSidebarRightExpand,
} from 'react-icons/tb';
import { useMainContext } from '../../hooks/useMainContext';
import { DownloadUtils } from '../../utils/DownloadUtils';

const DownloadClosetLayoutList = observer(() => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { apiManager } = useMainContext();
    const toggleSize = () => {
        setIsExpanded((prev) => !prev);
    };
    const formData = apiManager._libState.viewManager.formData;
    const allClosets = apiManager._libState.closetManager.closets || [];
    const closets = Array.from(
        new Map(allClosets.map((closet) => [closet.id, closet])).values(),
    );
    const handleDownloadAll = () => {
        closets.forEach((closet) => {
            handleDownload(closet);
        });
    };
    const handleDownload = (closet) => {
        const jsonData = apiManager.generateLayout(
            closet.id,
            closet,
            formData,
            false,
        );
        DownloadUtils.downloadJSON(
            jsonData,
            `${apiManager.projectId}_${closet.name}`,
        );
    };
    return (
        <div
            className={`possible-closet-list absolute top-[80px] right-[24px] min-h-[32px] min-w-[32px] rounded-[8px] bg-white shadow-custom z-50 ${isExpanded ? 'expanded' : 'shrunk'} transition-width duration-300`}
            style={{
                width: isExpanded ? '292px' : '20px',
                maxHeight: isExpanded ? '448px' : '20px', // Match icon size in shrunk state (header + content height in expanded state)
            }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: isExpanded ? '0' : '0',
                    padding: isExpanded ? '12px 16px' : '0', // Match original padding in expanded state, none in shrunk
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    borderBottom: isExpanded ? '1px solid #E5E5E5' : 'none', //
                    // Match border-bottom in expanded state
                }}>
                <Button
                    type="text"
                    icon={
                        isExpanded ? (
                            <TbLayoutSidebarLeftExpand />
                        ) : (
                            <TbLayoutSidebarRightExpand />
                        )
                    }
                    onClick={toggleSize}
                    style={{
                        fontSize: '20px',
                        padding: 0,
                        margin: 0,
                        color: '#1C1C1E',
                        borderRadius: '8px',
                    }}
                />
                {isExpanded && (
                    <div className="flex items-center justify-center gap-20">
                        <h1 className="font-favorite text-[18px] font-normal leading-[24px] text-[#1C1C1E]">
                            Closets
                        </h1>
                        <Tooltip title="Download All Closets Data">
                            <Button
                                type="text"
                                icon={<TbDownload />}
                                onClick={handleDownloadAll}
                                style={{
                                    fontSize: '18px',
                                    color: '#1C1C1E',
                                }}
                            />
                        </Tooltip>
                    </div>
                )}
            </div>
            {isExpanded && (
                <div className="content-container">
                    <div className="py-[16px] px-[8px] max-h-[400px] overflow-y-auto">
                        {closets.length > 0 ? (
                            closets.map((closet) => (
                                <div
                                    key={closet._id}
                                    className="flex justify-between items-center bg-gray-50 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors">
                                    <div className="truncate max-w-[200px] text-sm text-gray-800">
                                        {closet.name}
                                    </div>
                                    <Tooltip title="Download">
                                        <Button
                                            type="text"
                                            icon={<TbDownload />}
                                            onClick={() =>
                                                handleDownload(closet)
                                            }
                                            style={{ color: '#1C1C1E' }}
                                        />
                                    </Tooltip>
                                </div>
                            ))
                        ) : (
                            <div className="text-center text-gray-500">
                                No closets available
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
});

export default DownloadClosetLayoutList;
